import { ref } from 'vue'
import { useModelo } from '@/composables/model/useModelo.js'
import { useStore } from '@/composables/store/useStore.js'
import { storeToRefs } from 'pinia'

export function useTheme (dialogoMsg) {
  const store = useStore()
  const { colores } = storeToRefs(store)
  const formId = ref({ id: 0 })
  const form = ref({ user_id: null, theme: 1, loading: false })
  const error = ref({ descripcion: '' })
  const { fnCustomer, myForm } = useModelo('themes', dialogoMsg, formId, form)

  const fnTheme = (pForm, pResult, pLoading) => {
    fnCustomer('POST', 'themes', { form: pForm }, pResult, pLoading, 1)
  }

  const fnColor1 = () => {
    colores.value = { isDark: false, principal: 'teal-10', secundario: 'pink-10', tercero: 'white', cuarto: '#F5BDBD', boton1: 'indigo-10', fondo: 'grey-3', gradiente1: '#0d4837', gradiente2: '#0d4837', letra: 'teal-10', vista: 'blue', letraDark: 'black', letraLight: 'white', seleccion: 'orange-1', card1: 'grey-3', card2: 'grey-2', card3: 'grey-3', white: 'white', black: 'black', red: 'red', pink: 'pink', purple: 'purple', deepPurple: 'deep-purple', indigo: 'indigo', blue: 'blue', lightBlue: 'light-blue', cyan: 'cyan', teal: 'teal', green: 'green', lightGreen: 'light-green', lime: 'lime', yellow: 'yellow', amber: 'amber', orange: 'orange', deepOrange: 'deep-orange', brown: 'brown', grey: 'grey', blueGrey: 'blue-grey' }
    return colores.value
  }

  return { fnColor1, fnTheme, form, formId, myForm, error }
}
// ----------------------------------------------------------------------------------------------------
